import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { TUIGroupService, TUIUserService } from "@tencentcloud/chat-uikit-engine";
import { ref, computed, watch } from "../../../../adapter-vue";
import Dialog from "../../../common/Dialog/index.vue";
import Transfer from "../../../common/Transfer/index.vue";
import { isPC } from "../../../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 类型: voiceCall/groupCall/...
    type: {
      type: String,
      "default": ""
    },
    currentConversation: {
      type: Object,
      "default": {}
    },
    isGroup: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["submit", "cancel"],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var show = ref(false);
    var groupID = ref("");
    var memberList = ref([]);
    var searchMemberList = ref([]);
    var selfUserID = ref("");
    var titleMap = {
      voiceCall: "发起群语音",
      videoCall: "发起群视频"
    };
    var title = computed(function () {
      return titleMap[props.type] ? titleMap[props.type] : "";
    });
    TUIUserService.getUserProfile().then(function (res) {
      var _res$data;
      if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.userID) {
        selfUserID.value = res.data.userID;
      }
    });
    watch(function () {
      var _props$currentConvers;
      return [props === null || props === void 0 || (_props$currentConvers = props.currentConversation) === null || _props$currentConvers === void 0 ? void 0 : _props$currentConvers.conversationID, show.value];
    }, function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (props.isGroup && show.value) {
          groupID.value = props.currentConversation.groupProfile.groupID;
          TUIGroupService.getGroupMemberList({
            groupID: groupID.value
          }).then(function (res) {
            var _res$data2;
            memberList.value = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.memberList) === null || _res$data2 === void 0 ? void 0 : _res$data2.filter(function (user) {
              return (user === null || user === void 0 ? void 0 : user.userID) !== selfUserID.value;
            });
            searchMemberList.value = memberList.value;
          });
        } else {
          groupID.value = "";
          memberList.value = [];
          searchMemberList.value = memberList.value;
        }
      }
    }, {
      immediate: true
    });
    var search = function search(searchInfo) {
      var _memberList$value;
      var results = (_memberList$value = memberList.value) === null || _memberList$value === void 0 ? void 0 : _memberList$value.filter(function (member) {
        return (member === null || member === void 0 ? void 0 : member.userID) === searchInfo;
      });
      searchMemberList.value = results !== null && results !== void 0 && results.length ? results : memberList.value;
    };
    var submit = function submit(selectedMemberList) {
      var userIDList = [];
      selectedMemberList === null || selectedMemberList === void 0 || selectedMemberList.forEach(function (user) {
        (user === null || user === void 0 ? void 0 : user.userID) && userIDList.push(user.userID);
      });
      if (props.type === "voiceCall") {
        emits("submit", {
          userIDList: userIDList,
          groupID: groupID.value,
          type: 1
        });
      } else if (props.type === "videoCall") {
        emits("submit", {
          userIDList: userIDList,
          groupID: groupID.value,
          type: 2
        });
      }
      searchMemberList.value = memberList.value;
      toggleShow(false);
    };
    var cancel = function cancel() {
      searchMemberList.value = memberList.value;
      emits("cancel");
      toggleShow(false);
    };
    var toggleShow = function toggleShow(showStatus) {
      show.value = showStatus;
    };
    __expose({
      toggleShow: toggleShow
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Dialog, {
        show: _unref(show),
        isH5: !_unref(isPC),
        isHeaderShow: false,
        isFooterShow: false,
        background: false,
        "onUpdate:show": toggleShow
      }, {
        "default": _withCtx(function () {
          return [_createVNode(Transfer, {
            isSearch: true,
            title: _unref(title),
            list: _unref(searchMemberList),
            isH5: !_unref(isPC),
            isRadio: false,
            onSearch: search,
            onSubmit: submit,
            onCancel: cancel
          }, null, 8, ["title", "list", "isH5"])];
        }),
        _: 1
      }, 8, ["show", "isH5"]);
    };
  }
});